//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import debounce from "debounce";

export default {
    props: {
        value: { type: String },
        disabled: { type: Boolean, default: false },
        placeholder: { type: String, default: "BUSCAR" },
        showMessage: { type: Boolean, default: true }
    },
    data: function data() {
        return {
            term: ""
        };
    },

    watch: {
        value: function value(val) {
            this.term = val;
        }
    },
    computed: {
        withTooltip: function withTooltip() {
            return this.showMessage === true ? true : false;
        }
    },
    methods: {
        onSearch: debounce(function (val) {
            this.$emit("input", val);
        })
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/shared/search-box.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/shared/search-box.vue
// module chunks = 34